import { InputHTMLAttributes, forwardRef, ReactNode } from 'react';
import clsx from 'clsx';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  iconLeft?: ReactNode;
  iconRight?: ReactNode;
  invalid?: boolean;
}

// Same field styling as slightercrm/src/components/Input.tsx.
const base =
  'h-10 w-full rounded-lg border bg-surface text-sm text-text-primary placeholder:text-text-muted ' +
  'transition-colors duration-150 hover:border-border-strong ' +
  'focus:border-primary focus:outline-none focus:ring-4 focus:ring-primary-soft ' +
  'disabled:cursor-not-allowed disabled:opacity-60';

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ className, iconLeft, iconRight, invalid, ...rest }, ref) => {
    const cls = clsx(
      base,
      invalid ? 'border-danger focus:border-danger focus:ring-danger-soft' : 'border-border',
      iconLeft ? 'pl-10' : 'pl-3.5',
      iconRight ? 'pr-10' : 'pr-3.5',
      className,
    );
    if (!iconLeft && !iconRight) return <input ref={ref} aria-invalid={invalid || undefined} className={cls} {...rest} />;
    return (
      <div className="relative">
        {iconLeft && (
          <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-text-muted">{iconLeft}</span>
        )}
        <input ref={ref} aria-invalid={invalid || undefined} className={cls} {...rest} />
        {iconRight && (
          <span className="absolute inset-y-0 right-0 flex items-center pr-1.5 text-text-muted">{iconRight}</span>
        )}
      </div>
    );
  },
);
Input.displayName = 'Input';
